<template><section><h1>色彩</h1>
<blockquote>
<p>基础色 和 主题色</p>
</blockquote>
<h2>基础色</h2>
<p>基础色在 <code>/src/style/themes/colors/ui.styl</code> 文件中修改</p>
<p><color></color>
<color type="red"></color>
<color type="green"></color>
<color type="yellow"></color>
<color type="neutrals"></color></p>
<h2>主题色</h2>
<p>主题色在 <code>/src/style/themes/colors/vi.styl</code> 文件中修改</p>
<p><color type="vi"></color></p>
</section></template>

<script>
  import color from '@/pages/demo/Color.vue';

  export default {
    components: {
      color
    }
  }
</script>


// WEBPACK FOOTER //
// color-18.vue?278f3668